import moment from 'moment'
import _ from 'lodash'
import helpers from 'helpers'
import * as appConstants from 'constants/app'
import { merchant } from 'reducers/components/merchant'

class Merchant {
  openingsWithSurcharge
  storeDeliveryTimeslots = []
  takeawayTimeslots = []
  availableShippings = []

  constructor (merchant) {
    Object.assign(this, merchant)
    window.merchant = this
  }

  getShippings (type) {
    if (this.shippings) {
      this.availableShippings = this.shippings.filter(s => s.enabled && s.type === type)
      return this.availableShippings
    }
  }

  getActiveOpening (t, type) {
    const types = {
      takeaway: false,
      storeDelivery: false,
    }
    types[type] = true

    if (
      this.disabled ||
      (types.takeaway && this.takeawayDisabled)
    ) {
      return null
    }
    if (!this.openingsWithSurcharge) {
      return null
    }
    const day = '' + moment(t).day()
    if (day in this.openingsWithSurcharge) {
      const openings = this.openingsWithSurcharge[day]
      for (const o of openings) {
        const opening = new MerchantOpening(o)
        if (types.takeaway && !opening.takeaway) {
          continue
        }
        if (types.storeDelivery && !opening.storeDelivery) {
          continue
        }
        const is24Hour = opening.start === 0 && opening.startMin === 0 && opening.end === 0 && opening.endMin === 0
        if (is24Hour || opening.isInclude(t)) {
          return opening
        }
      }
    }
    return null
  }

  getFutureStoreDeliveryTimeslots = (deliveryTime) => {
    // shouldnt cache?
    // if (this.storeDeliveryTimeslots.length) {
    //   return this.storeDeliveryTimeslots
    // }
    if (!this.setting.storeDelivery) {
      return []
    }
    const storeDeliveryShippings = this.shippings.filter(o => o.type === 'storeDelivery' && o.enabled)
    if (!storeDeliveryShippings.length) {
      return []
    }

    const timeslots = []
    const timeslotDuration = appConstants.STOREDELIVERY_TIMESLOT_DURATION
    const estimatedShippingTime = appConstants.ESTIMATED_SHIPPING_TIME
    const bufferTime = appConstants.LALAMOVE_BUFFER

    // round to closest timeslot
    const now = helpers.date.round(moment(), moment.duration(timeslotDuration, 'minutes'), 'ceil')
    const maxDeliveryHour = _.maxBy(storeDeliveryShippings, 'maxDeliveryHour').maxDeliveryHour
    const minDate = moment().add(deliveryTime || estimatedShippingTime, 'minutes')
    const maxDate = now.clone().add(maxDeliveryHour, 'hour')

    for (let i = 0, d = minDate.clone(); i < 10000; i++) {
      if (d > maxDate) {
        break
      }

      if (this.getActiveOpening(d, 'storeDelivery')) {
        if (i === 0) {
          timeslots.push(d.clone())
        } else {
          // 第一個加 15 分鐘 buff 之後的不加
          timeslots.push(d.clone().subtract(bufferTime, 'minutes'))
        }
      }
      d.add(timeslotDuration, 'minutes')
    }
    this.storeDeliveryTimeslots = timeslots
    return this.storeDeliveryTimeslots
  }

  getFutureTakeawayTimeslots = () => {
    if (this.takeawayTimeslots.length) {
      return this.takeawayTimeslots
    }
    if (this.takeawayDisabled) {
      return []
    }
    const timeslots = []
    const timeslotDuration = appConstants.TAKEAWAY_TIMESLOT_DURATION

    const now = moment()
    const minAfter = helpers.date.round(
      now.clone().add(this.setting.takeawayPickupAfterMins, 'minute'),
      moment.duration(1, 'second'),
      'floor',
    )

    const earliest = helpers.date.round(
      minAfter.clone().add(timeslotDuration, 'minute'),
      moment.duration(timeslotDuration, 'minute'),
      'floor',
    )
    // if ((earliest - minAfter) > moment.duration(5, 'minute')) {
    //   if (this.getActiveOpening(minAfter, 'takeaway')) {
    //     timeslots.push(minAfter.clone())
    //   }
    // }
    for (
      let i = 0, d = earliest.clone();
      (d - earliest) <= this.setting.takeawayMaxPickupMins * 60 * 1000 && i < 10000;
      i++, d.add(timeslotDuration, 'minutes')
    ) {
      if (this.getActiveOpening(d, 'takeaway')) {
        timeslots.push(d.clone())
      }
    }

    this.takeawayTimeslots = timeslots
    return this.takeawayTimeslots
  }

  findPaymentName = (paymentKey) => {
    if (paymentKey) {
      const payment = this.payments.find(p => p.key === paymentKey)
      // Customized payment
      if (payment && payment.name !== '') {
        return payment.name
      }
    } else {
      return ''
    }
  }
}

class MerchantOpening {
  start
  startMin
  end
  endMin
  orderBeforeMin
  takeaway
  storeDelivery
  surcharge
  constructor (data) {
    Object.assign(this, data)
  }

  isInclude (time) {
    const start = moment(time).clone().set({ hour: this.start, minute: this.startMin })
    const end = moment(time).clone().set({ hour: this.end, minute: this.endMin })
    return moment(time).isBetween(start, end, '[]') && moment(time).add(this.orderBeforeMin, 'm').isBefore(end)
  }
}

class MerchantShipping {
  key
  name
  cost
  minAmount
  type
  minDeliveryHour
  maxDeliveryHour
  enabled

  constructor (shipping) {
    Object.assign(this, shipping)
  }

  isAvailable (type, time) {
    if (!this.enabled) {
      return false
    }
    if (this.type !== type) {
      return false
    }
    const now = moment()

    const minDate = now.clone().add(this.minDeliveryHour, 'hour')
    const maxDate = now.clone().add(this.maxDeliveryHour, 'hour')

    return moment(time).isBetween(minDate, maxDate, '[]')
  }
}

export {
  Merchant,
  MerchantOpening,
  MerchantShipping,
}



// WEBPACK FOOTER //
// ./src/models/merchant.js